import React, { useState } from "react";
import styles from "./OsnovneTehnike.module.scss";
import { useTranslation } from "react-i18next";

const BASE = "/june2026/";

const FILES = {
  img1: "Screenshot 2026-06-26 at 18.42.16.png",
  img2: "Screenshot 2026-06-26 at 18.42.26.png",
  img3: "Screenshot 2026-06-26 at 18.42.33.png",
  img4: "Screenshot 2026-06-26 at 18.42.39.png",
  img5: "Screenshot 2026-06-26 at 18.42.50.png",
  img6: "Screenshot 2026-06-26 at 18.42.59.png",
  img7: "Screenshot 2026-06-26 at 18.43.15.png",
  img8: "Screenshot 2026-06-26 at 18.43.23.png",
  img9: "Screenshot 2026-06-26 at 18.43.33.png",
  img10: "Screenshot 2026-06-26 at 18.43.40.png",
  img11: "Screenshot 2026-06-26 at 18.43.45.png",
  img12: "Screenshot 2026-06-26 at 18.43.51.png",
  img13: "Screenshot 2026-06-26 at 18.43.59.png",
  img14: "Screenshot 2026-06-26 at 18.44.11.png",
  img15: "Screenshot 2026-06-26 at 18.44.20.png",
  img16: "Screenshot 2026-06-26 at 18.44.25.png",
  img17: "Screenshot 2026-06-26 at 18.44.30.png",
  img18: "Screenshot 2026-06-26 at 18.44.36.png",
  img19: "Screenshot 2026-06-26 at 18.44.41.png",
  img20: "Screenshot 2026-06-26 at 18.44.48.png",
  img21: "Screenshot 2026-06-26 at 18.44.53.png",
  img22: "Screenshot 2026-06-26 at 18.44.59.png",
  img23: "Screenshot 2026-06-26 at 18.45.08.png",
  img24: "Screenshot 2026-06-26 at 18.45.21.png",
  img25: "Screenshot 2026-06-26 at 18.45.28.png",
  img26: "Screenshot 2026-06-26 at 18.45.42.png",
  img27: "Screenshot 2026-06-26 at 18.45.48.png",
  img28: "Screenshot 2026-06-26 at 18.45.54.png",
  img29: "Screenshot 2026-06-26 at 18.46.06.png",
  img30: "Screenshot 2026-06-26 at 18.46.14.png",
  img31: "Screenshot 2026-06-26 at 18.46.15.png",
  img32: "Screenshot 2026-06-26 at 18.46.32.png",
  img33: "Screenshot 2026-06-26 at 18.46.39.png",
  img34: "Screenshot 2026-06-26 at 18.46.43.png",
  img35: "Screenshot 2026-06-26 at 18.46.48.png",
  img36: "Screenshot 2026-06-26 at 18.46.52.png",
};

const groups = [
  {
    key: "upoznaj",
    titleKey: "tehnike.grupaUpoznaj",
    items: [
      { file: FILES.img24, captionKey: "tehnike.upoznaj1" },
      { file: FILES.img23, captionKey: "tehnike.upoznaj2" },
    ],
  },
  {
    key: "osnove",
    titleKey: "tehnike.grupaOsnove",
    items: [
      { file: FILES.img7, captionKey: "tehnike.osnove1" },
      { file: FILES.img34, captionKey: "tehnike.osnove2" },
    ],
  },
  {
    key: "stavovi",
    titleKey: "tehnike.grupaStavovi",
    items: [
      { file: FILES.img30, captionKey: "tehnike.stavovi1" },
      { file: FILES.img31, captionKey: "tehnike.stavovi2" },
    ],
  },
  {
    key: "blokovi",
    titleKey: "tehnike.grupaBlokovi",
    items: [
      { file: FILES.img1, captionKey: "tehnike.blokovi1" },
      { file: FILES.img2, captionKey: "tehnike.blokovi2" },
      { file: FILES.img5, captionKey: "tehnike.blokovi3" },
      { file: FILES.img9, captionKey: "tehnike.blokovi4" },
      { file: FILES.img15, captionKey: "tehnike.blokovi5" },
      { file: FILES.img19, captionKey: "tehnike.blokovi6" },
      { file: FILES.img20, captionKey: "tehnike.blokovi7" },
      { file: FILES.img26, captionKey: "tehnike.blokovi8" },
      { file: FILES.img32, captionKey: "tehnike.blokovi9" },
      { file: FILES.img33, captionKey: "tehnike.blokovi10" },
    ],
  },
  {
    key: "udarciRukom",
    titleKey: "tehnike.grupaUdarciRukom",
    items: [
      { file: FILES.img3, captionKey: "tehnike.udarciRukom1" },
      { file: FILES.img6, captionKey: "tehnike.udarciRukom2" },
      { file: FILES.img29, captionKey: "tehnike.udarciRukom3" },
    ],
  },
  {
    key: "udarnePovrsine",
    titleKey: "tehnike.grupaUdarnePovrsine",
    items: [
      { file: FILES.img4, captionKey: "tehnike.udarnePovrsine1" },
      { file: FILES.img10, captionKey: "tehnike.udarnePovrsine2" },
      { file: FILES.img16, captionKey: "tehnike.udarnePovrsine3" },
      { file: FILES.img35, captionKey: "tehnike.udarnePovrsine4" },
    ],
  },
  {
    key: "nozneTehnike",
    titleKey: "tehnike.grupaNozneTehnike",
    items: [
      { file: FILES.img8, captionKey: "tehnike.nozneTehnike1" },
      { file: FILES.img11, captionKey: "tehnike.nozneTehnike2" },
      { file: FILES.img12, captionKey: "tehnike.nozneTehnike3" },
      { file: FILES.img13, captionKey: "tehnike.nozneTehnike4" },
      { file: FILES.img14, captionKey: "tehnike.nozneTehnike5" },
      { file: FILES.img17, captionKey: "tehnike.nozneTehnike6" },
      { file: FILES.img18, captionKey: "tehnike.nozneTehnike7" },
      { file: FILES.img21, captionKey: "tehnike.nozneTehnike8" },
      { file: FILES.img22, captionKey: "tehnike.nozneTehnike9" },
      { file: FILES.img25, captionKey: "tehnike.nozneTehnike10" },
      { file: FILES.img27, captionKey: "tehnike.nozneTehnike11" },
      { file: FILES.img28, captionKey: "tehnike.nozneTehnike12" },
      { file: FILES.img36, captionKey: "tehnike.nozneTehnike13" },
    ],
  },
];

const OsnovneTehnike = () => {
  const { t } = useTranslation();
  const [lightbox, setLightbox] = useState(null);

  return (
    <div className={styles.container}>
      <div className={styles.notice}>
        <h3>{t("tehnike.obavestenjeNaslov")}</h3>
        <p>{t("tehnike.obavestenjeTekst")}</p>
        <a href="/pdfs/PROGRAM ZA POLAGANJE ZA ŽUTI POJAS.docx" download>
          {t("tehnike.obavestenjeDugme")}
        </a>
      </div>

      <div className={styles.header}>
        <h2>{t("tehnike.naslov")}</h2>
        <h3 className={styles.podnaslov}>{t("tehnike.podnaslov")}</h3>
      </div>

      {groups.map((group) => (
        <div className={styles.group} key={group.key}>
          <h3 className={styles.groupTitle}>{t(group.titleKey)}</h3>
          <div className={styles.grid}>
            {group.items.map((item, i) => {
              const src = encodeURI(BASE + item.file);
              const caption = t(item.captionKey);
              return (
                <div
                  className={styles.card}
                  key={i}
                  onClick={() => setLightbox({ src, caption })}
                >
                  <div className={styles.imgWrap}>
                    <img src={src} alt={caption} loading="lazy" />
                  </div>
                  <p>{caption}</p>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {lightbox && (
        <div className={styles.lightbox} onClick={() => setLightbox(null)}>
          <button className={styles.closeBtn} onClick={() => setLightbox(null)}>
            &times;
          </button>
          <img src={lightbox.src} alt={lightbox.caption} onClick={(e) => e.stopPropagation()} />
          <p>{lightbox.caption}</p>
        </div>
      )}
    </div>
  );
};

export default OsnovneTehnike;
